import { Fragment, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import './MentionList.scss';

export const MentionList = forwardRef((props, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = (index) => {
    const item = props.items[index];

    if (item) {
      props.command(item);
    }
  };

  const upHandler = () => {
    if (!props.items.length) return;
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
  };

  const downHandler = () => {
    if (!props.items.length) return;
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    if (!props.items.length) return false;
    selectItem(selectedIndex);
    return true;
  };

  useEffect(() => setSelectedIndex(0), [props.items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        downHandler();
        return true;
      }

      if (event.key === 'Enter') {
        return enterHandler();
      }

      return false;
    },
  }));

  return (
    <div className="items" style={{ maxHeight: 310, overflow: 'auto', scrollbarWidth: 'thin' }}>
      {props.items.length ? (
        props.items.map((item, index) => {
          const previousGroup = props.items[index - 1]?.group;
          const showGroupHeader = item.group && item.group !== previousGroup;

          return (
            <Fragment key={item.id ?? item.label}>
              {showGroupHeader && <div className="item-group">{item.group}</div>}
              <button
                type="button"
                className={`item ${index === selectedIndex ? 'is-selected' : ''}`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  selectItem(index);
                }}
              >
                {item.label}
              </button>
            </Fragment>
          );
        })
      ) : (
        <div className="item">Kein Ergebnis</div>
      )}
    </div>
  );
});
